import { render, staticRenderFns } from "./PaywallMarquee.vue?vue&type=template&id=3e51640a&scoped=true"
import script from "./PaywallMarquee.vue?vue&type=script&lang=js"
export * from "./PaywallMarquee.vue?vue&type=script&lang=js"
import style0 from "./PaywallMarquee.vue?vue&type=style&index=0&id=3e51640a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e51640a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e51640a')) {
      api.createRecord('3e51640a', component.options)
    } else {
      api.reload('3e51640a', component.options)
    }
    module.hot.accept("./PaywallMarquee.vue?vue&type=template&id=3e51640a&scoped=true", function () {
      api.rerender('3e51640a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Paywall/components/PaywallMarquee.vue"
export default component.exports